// jQuery(document).ready(function() {
//     add_order();
// });

var order_entity_ajax = {};
function add_order(vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/order/add',
        onOpen: function (elm, popup) {
            load_order_selectors(elm, vars);

            elm.find('form').ajaxFormSubmit(function(data, last_form){
                elm.doneLoading();
                if(last_form.hasClass('header-fields')) {
                    elm.find('form.choose-products').find('table').reloadThisElement();
                    elm.find('.address-options-wrapper').html(data);
                } else if(last_form.hasClass('add-notes')) {
                    load_paperwork_preview(elm, last_form, 'order');
                } else if(last_form.hasClass('submit')) {
                    $('body').isLoading();
                    reload_location_if_needed();
                    if (!document.closeWindow) open_new_object(view_order, data);
                }
                ajax_popup_scroll_to_next_screen(function() {
                    var a = elm.find('.scroll-screen.active');
                    var next_form = a.find('form');
                    next_form.find('input.generated-input').remove();
                    last_form.find(':input').each(function() {
                        var name = $(this).attr('name');
                        var type = $(this).attr('type');
                        if(name != undefined && type != 'submit' && name != "_token" && (type != "checkbox" || $(this).is(':checked'))) {
                            const v = $(this).val();
                            if ($(this).prop('tagName') === 'TEXTAREA') {
                                next_form.append('<textarea style="display: none;" name="' + $(this).attr('name') + '" class="generated-input">' + v + '</textarea>');
                            } else {
                                next_form.append('<input type="hidden" name="'+$(this).attr('name')+'" value="' + v + '" class="generated-input" />');
                            }
                        }
                    });
                }.bind([elm, last_form]));
            }.bind([elm,popup]), function(xhr, status, error) {
                elm.doneLoading();
                console.log([status,error]);
                ajax_popup_set_scroll_screen_progress(elm);
            }.bind([elm,popup]), function() {
                elm.isLoading();
            });
        }
    });
    return false;
}
function delete_order(id, identifier, close = false) {
    return delete_paperwork_object('order', id, identifier, close);
}
function view_order(id, callback) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/order/view/'+id,
        onOpen: function(elm, popup) {
            load_order_selectors(elm);

            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('order', id);

                $('body').doneLoading();
                squde_reload_for_flashes();
                if(callback) {
                    callback(data, elm, popup);
                }
                if (document.closeWindow) popup.close();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function load_order_selectors(elm, vars, default_null_vall) {
    const $ = jQuery.noConflict();
    let loadContactSelector;
    let loadCompanySelector;

    loadContactSelector = function(val) {
        elm.find('input[name="client_id"]').val(null);
        elm.find('[data-contact-selector]').removeClass('has-special-selector').contactSelector(val).change(function() {
            var v = $(this).val();
            if(order_entity_ajax.contact !== undefined) {
                order_entity_ajax.contact.abort();
            }
            if(parseInt(v) > 0) {
                order_entity_ajax.contact = $.ajax({
                    url: "/ajax/getContacts",
                    data: {id: v},
                    success: function(data) {

                        if(data[0].company_id != null || data[0].company_ids.length > 0) {
                            var selected_company = parseInt(elm.find('[data-company-selector]').val());
                            if(selected_company > 0 && (selected_company !== data[0].company_id && data[0].company_ids.indexOf(selected_company) === -1)) {
                                var new_company_id = data[0].company_id;
                                if(new_company_id == null) {
                                    new_company_id = data[0].company_ids[0];
                                }
                                loadCompanySelector(new_company_id);
                            } else {
                                if(selected_company < 1) {
                                    elm.find('input[name="client_id"]').val(data[0].client_id);
                                }
                            }
                        } else {
                            loadCompanySelector(null);
                            elm.find('input[name="client_id"]').val(data[0].client_id);
                        }
                    }
                });
            }
        });
    }.bind([elm, order_entity_ajax, loadCompanySelector]);
    loadContactSelector((vars !== undefined && vars.values && vars.values.contact_id) ? vars.values.contact_id : elm.find('[data-contact-selector]').attr('data-current-value'));

    loadCompanySelector = function(val) {
        elm.find('input[name="client_id"]').val(null);
        elm.find('[data-company-selector]').removeClass('has-special-selector').companySelector(val).change(function() {
            var v = $(this).val();
            if(order_entity_ajax.company !== undefined) {
                order_entity_ajax.company.abort();
            }
            if(parseInt(v) > 0) {
                invoice_entity_ajax.company =  $.ajax({
                    url: "/ajax/getCompanies",
                    data: {id: v},
                    success: function(data) {
                        if(data[0].these_contacts.length > 0) {
                            //Continue if the chosen contact is not the same as the first contact
                            if (elm.find('[data-contact-selector]').val() > 0 && elm.find('[data-contact-selector]').val() !== data[0].these_contacts[0]) {
                                //Set the contactselector to the first contact, if the chosen contact is not in the array of these contacts
                                var chosen_contact_id = parseInt(elm.find('[data-contact-selector]').val());
                                var contacts = data[0].these_contacts;
                                if (contacts.indexOf(chosen_contact_id) === -1) {
                                    loadContactSelector(data[0].these_contacts[0]);
                                }
                            }
                        }
                        elm.find('input[name="client_id"]').val(data[0].client_id);
                    }
                });
            }
        });
    }.bind([elm, order_entity_ajax, loadContactSelector]);
    loadCompanySelector((vars !== undefined && vars.values && vars.values.company_id) ? vars.values.company_id : elm.find('[data-company-selector]').attr('data-current-value'));

    $('[data-quotation-selector]').quotationSelector();
    $('[data-employee-selector]').employeeSelector();

    order_load_product_selector(elm);
}
function order_load_product_selector(elm, client_id) {
    paperwork_load_product_selector(elm,order_entity_ajax, client_id);
}
function order_add_products(id, client_id) {
    paperwork_add_products('order', id, client_id);
    return false;
}
function order_mark_all_products_delivered(id) {
    const $ = jQuery.noConflict();

    $.post('/administration/order/markAllDelivered/' + id, () => {
        reload_location_if_needed(false);
    });
    return false;
}
function remove_product_from_order(id, new_order) {
    var $ = jQuery.noConflict();

    if(new_order == undefined) {
        new_order = 0;
    }
    var after_confirm = function() {
        $.post('/administration/order/remove_product',{id:id, new_order:new_order}, function() {
            $('.order-products-table').reloadThisElement();
            if(new_order == 0) {
                squde_flash("Artikel van order verwijderd");
                reload_location_if_needed(false);
            }
        });
    }

    if(id !== "new") {
        confirm("Weet u zeker dat u dit artikel van de order wilt verwijderen?", function() {
            after_confirm();
        });
    } else {
        after_confirm();
    }
    return false;
}
function view_order_product(id, new_order, client_id) {
    view_paperwork_product('order', id, new_order, client_id);
    return false;
}

function migrate_order(id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: `/administration/order/migrate/${id}`,
        onOpen: async function(elm, popup) {
            elm.isLoading();

            const { order, invoice, contract } = await $.getJSON(`/administration/order/migrate/${id}/getInfo`);

            const newQuoteProducts = order.order_product_destinations.filter((line) => line.destination === 'quote');
            const newOrderProducts = order.order_product_destinations.filter((line) => line.destination === 'order');
            const newInvoiceProducts = order.order_product_destinations.filter((line) => line.destination === 'invoice');


            const actionSelectForNonDeliveredProducts = elm.find('select[name="action_for_non_delivered_products"]');
            const actionSelectForNonCheckedDevices = elm.find('select[name="action_for_non_checked_devices"]');

            let devices = order.devices;
            const undeliveredProducts = order.products.filter((product) => !product.delivered);
            const unfinishedDevices = devices.filter((device) => !device.pivot.checked);



            // Write the header
            elm.find('.migrate-header').html(`Order #${order.uid} bevat ${order.devices.length} ${order.devices.length === 1 ? 'apparaat' : 'apparaten'} en ${order.products.length} ${order.products === 1 ? 'artikel' : 'artikelen'}.`);

            // Toggle contract question
            elm.find('.contract-info-wrapper').toggle(contract !== null);
            if (contract) {
                elm.find('.current-expiration-date-wrapper span').html(moment(contract.expires_at).format('DD-MM-YYYY'));
                // eg: 1 years
                let repeatAfter = contract.repeat_after;
                if (!repeatAfter) {
                    repeatAfter = '1 years';
                }
                const [number, unit] = repeatAfter.split(' ');
                const newDate = moment(contract.expires_at).add(number, unit);

                const expiresInFutureWithinAMonth = moment(contract.expires_at).isAfter(moment().add(1, 'month'));

                elm.find(`input[name="extend_contract"][value="${expiresInFutureWithinAMonth ? 0 : 1}"]`).prop('checked', true);

                elm.find('input[name="extend_contract"]').unbind('change').change(function() {
                    const extend = elm.find('input[name="extend_contract"][value="1"]:checked').length > 0;
                    elm.find('.new-contract-date').toggle(extend);
                    const newDateSpan = elm.find('.new-contract-date span');
                    newDateSpan.html(newDate.format('DD-MM-YYYY'));

                    if (!extend) return;

                    const input = elm.find('.new-contract-date input');
                    input.val(newDate.format('DD-MM-YYYY'));

                    input.unbind('change').change(function() {
                        const date = moment(input.val(), 'DD-MM-YYYY');
                        newDateSpan.html(date.format('DD-MM-YYYY'));
                    });
                }).trigger('change');

            }

            // Toggle invoice merge fn
            elm.find('.existing-invoice-question').toggle(invoice !== null);


            // Merge products fn
            const mergeProducts = (products, newProducts, args) => {
                newProducts.forEach((product) => {
                    const existingProduct = products.find((line) => line.product_id === product.id);
                    if (existingProduct) {
                        existingProduct.count += args.count || 1;
                    } else {
                        const productArgs = Object.assign({}, {
                            count: 1,
                            delivered: 0,
                            product,
                            product_id: product.id,
                        }, args);
                        products.push(productArgs);
                    }
                });
            }

            // Sum products fn
            const sumProducts = (products) => {
                // find the product with the same id and product.name and sum the count
                return products.reduce((acc, line) => {
                    const existingProduct = acc.find((product) => product.product_id === line.product_id && product.product.name === line.product.name);
                    if (existingProduct) {
                        existingProduct.count += line.count;
                    } else {
                        acc.push(line);
                    }
                    return acc;
                }, []);
            }

            const informFollowup = () => {

                const orderInfoWrapper = elm.find('.followup-order-overview-wrapper');
                const followupFieldset = orderInfoWrapper.closest('fieldset');
                followupFieldset.toggle(newOrderProducts.length > 0 || newQuoteProducts.length > 0);
                const actionForNoneDeliveredProducts = actionSelectForNonDeliveredProducts.val();
                const actionForNoneCheckedDevices = actionSelectForNonCheckedDevices.val();


                // Write order numbers
                const orderProducts = JSON.parse(JSON.stringify(newOrderProducts));
                if (actionForNoneDeliveredProducts === 'deliver_on_new_order') {
                    mergeProducts(orderProducts, undeliveredProducts, {
                        delivered: 1,
                        destination: 'order',
                        order_id: id,
                    });
                }
                if (actionForNoneCheckedDevices === 'replace_later') {
                    unfinishedDevices.forEach((device) => {
                        const products = [
                            device.product,
                            device.product.device_product_status_products.find((line) => line.pivot.device_status === 'INSTALLED'),
                        ].filter(Boolean);

                        mergeProducts(orderProducts, products, {
                            delivered: 1,
                            destination: 'order',
                            device_id: device.id,
                            order_id: id,
                        });

                    });
                }
                orderInfoWrapper.toggle(orderProducts.length > 0);
                const orderInfoUl = orderInfoWrapper.find('ul');
                orderInfoUl.empty();
                sumProducts(orderProducts).forEach((line) => {
                    orderInfoUl.append(`<li>${line.count}&times; <a href="#" onclick="view_product(${line.product_id}); return false;">${line.product.name}</a></li>`);
                });

                // Write quote numbers
                const quoteInfoWrapper = elm.find('.followup-quote-overview-wrapper');
                const quoteProducts = JSON.parse(JSON.stringify(newQuoteProducts));

                if (actionForNoneDeliveredProducts === 'make_quote') {
                    mergeProducts(quoteProducts, undeliveredProducts, {
                        delivered: 1,
                        destination: 'quote',
                        order_id: id,
                    });
                }
                if (actionForNoneCheckedDevices === 'make_quote') {
                    unfinishedDevices.forEach((device) => {
                        const products = [
                            device.product,
                            device.product.device_product_status_products.find((line) => line.pivot.device_status === 'INSTALLED'),
                        ].filter(Boolean);

                        mergeProducts(quoteProducts, products, {
                            delivered: 1,
                            destination: 'quote',
                            device_id: device.id,
                            order_id: id,
                        });

                    });
                }

                quoteInfoWrapper.toggle(quoteProducts.length > 0);
                const quoteInfoUl = quoteInfoWrapper.find('ul');
                quoteInfoUl.empty();
                sumProducts(quoteProducts).forEach((line) => {
                    quoteInfoUl.append(`<li>${line.count}&times; <a href="#" onclick="view_product(${line.product_id}); return false;">${line.product.name}</a></li>`);
                });


                // Write invoice numbers
                const invoiceProducts = JSON.parse(JSON.stringify(newInvoiceProducts));
                const invoiceInfoWrapper = elm.find('.invoice-overview-wrapper');
                const invoiceFieldset = invoiceInfoWrapper.closest('fieldset');

                if (actionForNoneDeliveredProducts === 'mark_delivered') {
                    mergeProducts(invoiceProducts, undeliveredProducts, {
                        delivered: 1,
                        destination: 'invoice',
                        order_id: id,
                    });
                }
                if (actionForNoneCheckedDevices === 'approve') {
                    unfinishedDevices.forEach((device) => {
                        mergeProducts(invoiceProducts, [device.product.device_product_status_products.find((line) => line.pivot.device_status === 'APPROVED')], {
                            delivered: 1,
                            destination: 'invoice',
                            device_id: device.id,
                            order_id: id,
                        });
                    });
                }
                invoiceFieldset.toggle(invoiceProducts.length > 0);
                const invoiceInfoUl = invoiceInfoWrapper.find('ul');
                invoiceInfoUl.empty();
                sumProducts(invoiceProducts).forEach((line) => {
                    invoiceInfoUl.append(`<li>${line.count}&times; <a href="#" onclick="view_product(${line.product_id}); return false;">${line.product.name}</a></li>`);
                });

            }
            informFollowup();

            const nonDeliveredProductsDiv = actionSelectForNonDeliveredProducts.closest('div');
            nonDeliveredProductsDiv.toggle(undeliveredProducts.length > 0);
            nonDeliveredProductsDiv.find('.undelivered-products-header').html(`Er ${undeliveredProducts.length === 1 ? 'is' : 'zijn'} ${undeliveredProducts.length} product${undeliveredProducts.length === 1 ? '' : 'en'} niet geleverd. Wat moet hiermee gebeuren?`);
            actionSelectForNonDeliveredProducts.unbind('change').change(informFollowup);

            const nonCheckedDevicesDiv = actionSelectForNonCheckedDevices.closest('div');
            nonCheckedDevicesDiv.toggle(unfinishedDevices.length > 0);
            nonCheckedDevicesDiv.find('.unfinished-devices-header').html(`Er ${unfinishedDevices.length === 1 ? 'is' : 'zijn'} ${unfinishedDevices.length} ${unfinishedDevices.length === 1 ? 'apparaat' : 'apparaten'} niet gecontroleerd. Wat moet hiermee gebeuren?`);
            actionSelectForNonCheckedDevices.unbind('change').change(informFollowup);



            elm.find('form').ajaxFormSubmit(function(data) {
                squde_reload_for_flashes(function() {
                    reload_location_if_needed(true, function() {
                        if (data.order !== null) {
                            view_order(data.order.id);
                        } else {
                            view_invoice(data.invoice.id);
                        }
                    });
                });


            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });


            // elm.isLoading();
            // setTimeout(() => {
            //     if (elm.find('.inquiry-wrapper').children('.row:visible').length === 0) {
            //         elm.find('form').submit();
            //     } else {
            //         elm.doneLoading();
            //     }
            // }, 1000);
        }
    });
    return false;
}
function plan_order(id) {
    setRealCookie('run_v2', 1, 1)
    redirect_and_do('/inspections/board', () => {}, true, {id});
}
function make_order_actions(sender, order_id, client_id) {
    const $ = jQuery.noConflict();
    const action_id = $(sender).find('select').val();

    if (action_id < 1) {
        return false;
    }

    const make_actions = function(device_ids = null) {
        $.post('/administration/order/makeActionsForOrder/' + order_id + '/' + action_id, {device_ids}, function() {
            reload_location_if_needed(false);
        });
    };

    $.get('/actions/' + action_id, function(action) {
        if (action.device_category_id > 0) {
            choose_devices_and_callback(client_id, {device_category_id: action.device_category_id}, function(device_ids) {
                make_actions(device_ids);
            });
        } else {
            make_actions();
        }
    });
    return false;
}
// function delete_order_action(order_action_id) {
//     const $ = jQuery.noConflict();
//
//     custom_delete_with_confirmation('/administration/order/removeActionFromOrder/' + order_action_id, order_action_id, 'Weet u zeker dat u deze actie van de order wilt verwijderen?', 'orderAction', function() {
//         reload_location_if_needed(false);
//     });
//     return false;
// }
// function put_actions_to_products(order_id) {
//     const $ = jQuery.noConflict();
//
//     $.post('/administration/order/putActionsToProducts/' + order_id, {}, function() {
//         reload_location_if_needed(false, function() {
//             $('.reveal-overlay:visible:last').find('#link-to-products').trigger('click');
//         });
//     });
//     return false;
// }

function print_inspections_from_orders() {
    const selection = window.selected_orders;
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/administration/orders/print',
        data: {ids: selection},
        size: 'small',
        onOpen: function (elm, popup) {
            elm.find('form').submit(function(e) {
                e.preventDefault();
                const data = $(this).serializeJSON();
                print_collection(data.layout, data.ids);
                return false;
            });
        }
    });
    return false;
}
function delete_order_device(order_id, device_id) {
    const $ = jQuery.noConflict();
    confirm('Weet u zeker dat u dit apparaat van de order wilt verwijderen?', function() {
        $.post(`/administration/order/removeDeviceFromOrder/${order_id}/${device_id}`)
            .done(function() {
                squde_reload_for_flashes();
                reload_location_if_needed(false);
            })
            .fail(function(error) {
                console.error(error);
            });
    });
    return false;
}
function attach_device_to_order_from_select(sender, order_id) {
    const $ = jQuery.noConflict();
    attach_device_to_order(order_id, ($(sender).serializeJSON()).device_id);
    return false;
}
function attach_device_to_order(order_id, device_id) {
    jQuery.post(`/administration/order/attachDeviceToOrder/${order_id}/${device_id}`)
        .done(function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        })
        .fail(function(reason) {
            console.error(reason);
        })
}
function generate_work_order(order_id) {
    const $ = jQuery.noConflict();
    $('body').isLoading();
    $.post(`/administration/order/generateWorkOrder/${order_id}`)
        .done(function(url) {
            window.location.replace(url);
        })
        .fail(function(error) {
            console.error(error);
        })
        .always(function() {
            $('body').doneLoading();
        });
    return false;
}

function attach_contact_to_order(sender, order_id) {
    const $ = jQuery.noConflict();
    const contact_id = $(sender).serializeJSON().contact_id;

    $.post(`/administration/order/attachContactToOrder/${order_id}/${contact_id}`)
        .done(function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        })
        .fail(function(reason) {
            console.error(reason);
        });
    return false;
}

function detach_contact_from_order(order_id, contact_id) {
    const $ = jQuery.noConflict();
    $.post(`/administration/order/detachContactFromOrder/${order_id}/${contact_id}`)
        .done(function() {
            squde_reload_for_flashes();
            reload_location_if_needed(false);
        })
        .fail(function(reason) {
            console.error(reason);
        });
    return false;
}
